import './footer.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import FBImage from '../../assets/facebook.svg';
import { MMTInfo } from '../../config';
import {
    ExemptionDocument,
    OrderFormDocument,
    ShippingLabelDocument,
    LaceyActDocument,
} from '../../assets/pdfs';

function footer() {
    return (
        <>
            <div className="footer">
                <div className="container">
                    <div className="content">
                        <div>
                            <h3>Moyle Mink & Tannery, Inc. Licenses & Permits</h3>
                            <p>
                                Idaho Taxidermist and Fur Buyer License No. 729-18-000001
                                <br />
                                USFWS Marine Mammal Registered Tannery Permit No. LE49741D-0
                                <br />
                                NOAA/National Marine Fisheries Service Certificate of Registration
                                No. 120 File No. T120/A120
                                <br />
                                USFWS Import/Export License Permit No. 090427
                            </p>
                            <p className="usda">USDA APPROVED & CERTIFIED</p>
                        </div>
                        <div>
                            <h3>Forms/PDFs</h3>
                            <Link to={{ pathname: '/prices' }}>Price Lists</Link>

                            <a
                                href={ExemptionDocument.file}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Idaho State Exemption Form
                            </a>

                            <a
                                href={OrderFormDocument.file}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Order Form
                            </a>

                            <a
                                href={ShippingLabelDocument.file}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Shipping Label
                            </a>

                            <a
                                href={LaceyActDocument.file}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Lacey Act
                            </a>
                        </div>
                        <div>
                            <h3>Resources</h3>
                            <Link to={{ pathname: '/resources', hash: '#skin-prep' }}>
                                Preparation/Tips
                            </Link>

                            <Link to={{ pathname: '/resources', hash: '#shipping' }}>Shipping</Link>

                            <Link to={{ pathname: '/resources', hash: '#terms-and-conditions' }}>
                                Terms
                            </Link>
                            <Link to={{ pathname: '/resources', hash: '#legal-faqs' }}>
                                Legal FAQs
                            </Link>
                            <Link to={{ pathname: '/resources', hash: '#wildlife-law-resources' }}>
                                Wildlife Law Resources
                            </Link>
                            <Link to={{ pathname: '/resources', hash: '#links' }}>Links</Link>
                        </div>
                        <div>
                            <h3>Useful Links</h3>
                            <Link
                                to={{
                                    pathname: '/legal-compliance',
                                }}
                            >
                                Legal Compliance
                            </Link>

                            <Link
                                to={{
                                    pathname: '/privacy-policy',
                                }}
                            >
                                Privacy Policy
                            </Link>
                        </div>
                        <div>
                            <p>
                                1-866-TAN-FURS
                                <br />
                                (1-866-826-3877)
                            </p>
                            <a
                                href={`https://www.facebook.com/${MMTInfo.facebookId}/`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={FBImage}
                                    width={25}
                                    height={25}
                                    alt="Follow us on Facebook"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="subfooter">
                <div className="container">
                    <div className="content">
                        <p>
                            &copy; {new Date().getFullYear()}
                            &nbsp; Moyle Mink & Tannery. All Rights Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default footer;
